export const stringToClipboard = async (
	callback: () => Promise<string | undefined>
): Promise<boolean> => {
	const res = await callback();
	if ( !res ) return false;
	try {
		await navigator.clipboard.writeText( res );
		return true;
	} catch ( error ) {
		console.log( 'Ignoring error:', error );
		return false;
	}
};
